var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"side-catalog"},[_c('div',{staticClass:"side-catalog__title"},[_vm._t("default")],2),_vm._l((_vm.catalogList),function(item){return _c('div',{key:item.ref,staticClass:"side-catalog__item",class:{
        'side-catalog__item--child': _vm.isChildren(item.level),
      },on:{"click":function($event){return _vm.anchorActive(item.ref)}}},[_c('div',{staticClass:"side-catalog__item-title",class:[
          { 'side-catalog__item-title--active': _vm.active === item.ref },
          `side-catalog__item--level${item.level || 1}`,
        ],attrs:{"title":item.title}},[_c('p',[_vm._v(_vm._s(item.title))])])])})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }